import { useState } from 'react';
import { Button } from '@heroui/react';
import { useViewerStore } from '@stores/viewerStore';
import { updatePublishStatus } from '@services/share';

/** 发布状态切换控件（仅创作者可见）。 */
export function PublishControl() {
  const publishStatus = useViewerStore((s) => s.publishStatus);
  const setPublishStatus = useViewerStore((s) => s.setPublishStatus);
  const sceneId = useViewerStore((s) => s.sceneId);
  const [loading, setLoading] = useState(false);

  const isPublished = publishStatus === 'published';

  async function handleToggle() {
    if (!sceneId) return;
    const next = isPublished ? 'unpublished' : 'published';
    setLoading(true);
    try {
      await updatePublishStatus(sceneId, next);
      setPublishStatus(next);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="border-t border-white/10 pt-4">
      <p className="mb-2 text-xs font-medium text-white/70">Publish Status</p>
      <div className="flex items-center justify-between">
        <span className="text-sm text-white">
          {isPublished ? '✅ Published' : '⏸️ Unpublished'}
        </span>
        <Button
          size="sm"
          isPending={loading}
          onPress={() => void handleToggle()}
          className="rounded-full bg-white/10 text-xs text-white hover:bg-white/20"
        >
          {isPublished ? 'Unpublish' : 'Publish'}
        </Button>
      </div>
    </div>
  );
}
